import type { Store } from '../store/types';
import { getB2BOrganizations } from 'api/get-b2b-organizations';
import { B2B_ORGANIZATION_ACTIONS } from 'actions/b2b-organization';
import { B2BOrganization } from 'types/b2b-organization';
import { writeCurrentOrganizationNumberToCookie } from 'utils/b2b-utils';

const checkAndSetCurrentOrganizationNumber = (
  store: Store,
  state: B2BOrganizationsStore,
  list: B2BOrganization[],
) => {
  store.dispatch(B2B_ORGANIZATION_ACTIONS.success, list);
  const currentOrganizationNumber = state.B2BOrganizations.currentOrganizationNumber;

  if (list.length > 0) {
    const organization = list.find((el) => el.organizationNumber === currentOrganizationNumber);
    const newOrganizationNumber = organization
      ? organization.organizationNumber
      : list[0].organizationNumber;

    store.dispatch(B2B_ORGANIZATION_ACTIONS.setCurrentOrganizationNumber, newOrganizationNumber);
  }
};

export const b2bOrganizationReducer = (store: Store) => {
  store.on('@init', () => {
    return {
      B2BOrganizations: {
        list: [],
        loading: false,
      },
    } as B2BOrganizationsStore;
  });

  store.on(B2B_ORGANIZATION_ACTIONS.init, (state) => {
    const { orchestratorBackendHost, useCredentials, apiKey, requestID } = store.get();

    store.dispatch(B2B_ORGANIZATION_ACTIONS.request);

    getB2BOrganizations({
      orchestratorHost: orchestratorBackendHost,
      useCredentials,
      apiKey,
      requestID,
    })
      .then((list) => checkAndSetCurrentOrganizationNumber(store, state, list))
      .catch((e) => store.dispatch(B2B_ORGANIZATION_ACTIONS.failure, e));
  });

  store.on(B2B_ORGANIZATION_ACTIONS.request, (state: B2BOrganizationsStore) => {
    const newState = { ...state };
    newState.B2BOrganizations.loading = true;

    return newState;
  });

  store.on(B2B_ORGANIZATION_ACTIONS.failure, (state: B2BOrganizationsStore, error) => {
    const newState = { ...state };
    newState.B2BOrganizations.loading = false;
    newState.B2BOrganizations.error = error;

    return newState;
  });

  store.on(B2B_ORGANIZATION_ACTIONS.success, (state: B2BOrganizationsStore, list: B2BOrganization[]) => {
    const newState = { ...state };
    newState.B2BOrganizations.loading = false;
    newState.B2BOrganizations.list = list;

    return newState;
  });

  store.on(
    B2B_ORGANIZATION_ACTIONS.setCurrentOrganizationNumber,
    (state: B2BOrganizationsStore, currentNumber: string) => {
      writeCurrentOrganizationNumberToCookie(currentNumber);

      const newState = { ...state };
      newState.B2BOrganizations.currentOrganizationNumber = currentNumber;

      const organization = newState.B2BOrganizations.list.find(
        (el) => el.organizationNumber === currentNumber,
      );

      if (organization) {
        newState.B2BOrganizations.currentOrganizationName = organization.name;
      }

      return newState;
    },
  );
};

export type B2BOrganizationsStore = {
  B2BOrganizations: {
    list: B2BOrganization[];
    loading: boolean;
    error?: Error;
    currentOrganizationNumber?: string;
    currentOrganizationName?: string;
  };
};
